import type { AuditEvent } from "../model/AuditEvent";
import API, { responseOf } from "./base";

export const getByProcessExecutionId = (
  organizationId: string,
  processExecutionId: string,
): Promise<AuditEvent[]> =>
  responseOf(
    API.get(
      `/audit-events/${organizationId}/processExecution/${processExecutionId}`,
    ),
  );
